/**
 * Used in JSON.stringfy to replace Error object with a serializable one.
 *
 * @param key the key in the obejct to be stringfied.
 * @param value the value of certain field in the object to be stringfied.
 * @returns object value itself or the parsed object for JSON.stringfy
 */
export function errorObjectReplacer(key, value) {
    if (value instanceof Error) {
        const error = {};
        Object.getOwnPropertyNames(value).forEach(function (errorPropName) {
            // safe to cast to any b/c propName is a key of value
            error[errorPropName] = value[errorPropName];
        });
        return error;
    }
    return value;
}
//# sourceMappingURL=ErrorObjectReplacer.js.map